const GROUP_ERROR_CODES = [
  'config_download_failed',
  'config_invalid',
  'model_download_failed',
  'image_pull_failed',
  'image_incompatible',
  'no_allowed_gpu',
  'insufficient_gpu_memory',
  'engine_build_failed',
  'static_batch_model',
  'engine_unavailable',
  'gpu_unavailable',
  'container_start_failed',
  'pipeline_error',
  'pipeline_frozen',
  'internal_error'
] as const

const ENGINE_ERROR_CODES = [
  'invalid_spec',
  'model_missing',
  'static_batch',
  'build_failed',
  'out_of_memory',
  'timeout',
  'validation_failed',
  'unsupported_input_shape',
  'gpu_unavailable'
] as const

const WARNING_CODES = [
  'milestone_unreachable',
  'vp_agent_registration_failed',
  'ocr_unavailable',
  'gpu_reserved_by_vlm',
  'gpu_memory_estimate_exceeds_capacity',
  'fps_below_target',
  'delivery_backlog',
  'events_rejected',
  'clips_failing',
  'gpu_saturated',
  'tracking_off'
] as const

const messageIdFor = (
  codes: readonly string[],
  prefix: string,
  code: string | null | undefined
) => {
  return code && codes.includes(code) ? `${prefix}.${code}` : null
}

export const getGroupErrorMessageId = (code: string | null | undefined) => {
  return messageIdFor(GROUP_ERROR_CODES, 'deployments.groups.error', code)
}

export const getEngineErrorMessageId = (code: string | null | undefined) => {
  return messageIdFor(
    ENGINE_ERROR_CODES,
    'deployments.groups.engine.error',
    code
  )
}

export const getGroupWarningMessageId = (code: string | null | undefined) => {
  return messageIdFor(WARNING_CODES, 'deployments.groups.warning', code)
}

export const getGroupWarningBadgeMessageId = (
  code: string | null | undefined
) => {
  return messageIdFor(WARNING_CODES, 'deployments.groups.warning.badge', code)
}
